export const FeedbackMap = new Map<number,string>();

FeedbackMap.set(1, 'MIS dashboard');
FeedbackMap.set(2, 'Download and share invoices');
FeedbackMap.set(3, 'QR scanner');
FeedbackMap.set(4, 'Loading Times');

export enum FdbkStatus {
    BAD = 'BAD',
    OKAY = 'OKAY',
    GREAT = 'GREAT',
  }
  